import { useQuery } from '@tanstack/react-query';
import BaseFetchOptions from 'src/data/api/common/BaseFetchOptions';
import ticketLinkImportService from 'src/data/services/ticketLinkImportService';

export const FETCH_TICKET_LINK_IMPORT_ROWS_QUERY_KEY = 'FETCH_TICKET_LINK_IMPORT_ROWS';

export const useFetchTicketLinkImportRows = (
    ticketLinkImportId: string | null,
    failedRowsOnly: boolean,
    options?: BaseFetchOptions
) => {
    return useQuery({
        queryKey: [
            FETCH_TICKET_LINK_IMPORT_ROWS_QUERY_KEY,
            ticketLinkImportId,
            failedRowsOnly,
            options,
        ],
        queryFn: () =>
            ticketLinkImportService.getTicketLinkImportRows(
                ticketLinkImportId!,
                failedRowsOnly,
                options
            ),
        enabled: ticketLinkImportId !== null,
        keepPreviousData: true,
    });
};
